module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5NHNP"))).then(() => module.bundle.root('6TueN'));